import type { VariantProps } from '@gluestack-ui/nativewind-utils'
import { forwardRef, type ComponentRef } from 'react'
import { View, type ViewProps } from 'react-native'

import { vstackStyle } from './styles'

export type VStackProps = ViewProps & VariantProps<typeof vstackStyle>

export const VStack = forwardRef<ComponentRef<typeof View>, VStackProps>(
  ({ className, space, reversed, ...props }, ref) => (
    <View
      className={vstackStyle({ space, reversed, class: className })}
      ref={ref}
      {...props}
    />
  )
)

VStack.displayName = 'VStack'
